<template>
  <v-toolbar class="elevation-1">
    <img
      v-if="institution"
      :src="institution.institution_logo"
      alt="logo"
      width="auto"
      height="64px"
      class="logo"
    />

    <!--  <v-btn v-if="responsive" dark icon color="primary" @click="toggleDrawer">
      <v-icon>menu</v-icon>
    </v-btn> -->
    <v-spacer />
    <!-- <v-avatar v-if="user" size="35px" class="orange">
      <span class="white--text title"
        >{{ user.nombre[0] }}{{ user.apellido[0] }}</span
      >
    </v-avatar> -->
    <!-- <span v-if="user" class="ml-2 mr-5 subheading"
      >{{ user.nombre }} {{ user.apellido }}</span
    > -->
    <template v-slot:extension>
      <ul class="nav-list">
        <li
          v-for="link in routes"
          :key="link.to"
          :class="{ 'item-active': isActive(link.to) }"
        >
          <router-link :to="link.to">
            <i name="icon" :class="link.icon" class="p-mx-2"></i>
            <span v-if="!responsive"> {{ link.name }} </span>
          </router-link>
        </li>
      </ul>
      <v-spacer />
      <div v-if="user" class="user-dropdown mx-2">
        <span class="label">{{ user.nombre }} {{ user.apellido }}</span>
        <div class="user-dropdown-content">
          <InstitutionSelect class="user-dropdown-item" />
          <RoleSelect class="user-dropdown-item" />
          <span
            style="margin: 0.5rem 0;"
            v-for="item in items"
            :key="item.label"
            @click="item.command"
          >
            <i name="icon" :class="item.icon"></i>
            {{ item.label }}
          </span>
        </div>
      </div>
      <!-- <SplitButton
        v-if="user"
        class="p-button-outlined"
        :label="`${user.nombre} ${user.apellido}`"
        :model="items"
      /> -->
    </template>
  </v-toolbar>
</template>

<script>
import { mapState } from "vuex";
import Role from "@/utils/role";
import CredentialServices from "@/services/Credentials.service.js";
import InstitutionSelect from "./Toolbar/InstitutionSelect.vue";
import RoleSelect from "./Toolbar/RoleSelect.vue";
export default {
  components: { RoleSelect, InstitutionSelect },
  data() {
    return {
      responsive: false,
      credentialService: new CredentialServices(),
      items: [
        {
          label: "Editar Perfil",
          icon: "pi pi-user-edit",
          command: () => {
            this.toPerfil();
          }
        },
        {
          label: "Cerrar Sesión",
          icon: "pi pi-sign-out",
          command: () => {
            this.logout();
          }
        }
      ]
    };
  },
  computed: {
    ...mapState({
      user: state => state.user,
      role: state => state.role,
      institution: state => state.institution,
      currentCourse: state => state.navigation.currentCourse
    }),
    routes() {
      if (localStorage.getItem("role") === Role.STUDENT) {
        return [
          {
            name: "Cursos",
            to: "/student/courses",
            icon: "pi pi-book"
          },
          {
            name: "Calificaciones",
            to: "/student/qualification",
            icon: "pi pi-check-circle"
          },
          {
            name: "Eventos",
            to: "/student/events",
            icon: "pi pi-calendar"
          },
          {
            name: "Asistencias",
            to: "/student/attendance/showcourse",
            icon: "pi pi-list"
          }
        ];
      }
      if (localStorage.getItem("role") === Role.TEACHER) {
        return [
          {
            name: "Cursos",
            to: "/learning/courses",
            icon: "pi pi-book"
          },
          {
            name: "Estudiantes",
            to: "/learning/students",
            icon: "pi pi-users"
          },
          {
            name: "Calificaciones",
            to: "/learning/qualifications",
            icon: "pi pi-check-circle"
          },
          {
            name: "Asistencias",
            to: "/learning/attendance/showcourse",
            icon: "pi pi-list",
          },
        ];
      }

      if (localStorage.getItem("role") === Role.ADMIN) {
        return [
          {
            name: "Cursos",
            to: "/learning/admin/courses",
            icon: "pi pi-book"
          },
          {
            name: "Profesores",
            to: "/learning/teachers",
            icon: "pi pi-briefcase"
          },
          {
            name: "Estudiantes",
            to: "/learning/students",
            icon: "pi pi-users"
          },
          {
            name: "Administrador",
            to: "/learning/showmaintainer",
            icon: "pi pi-users"
          },
          {
            name: "Asistencias",
            to: "/learning/attendance/showcourse",
            icon: "pi pi-list"
          }
        ];
      }
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    isActive(route) {
      return this.$route.path.includes(route);
    },
    logout() {
      this.credentialService.clearCredentials();
      this.$router.push("/auth/login");
    },
    toPerfil() {
      if (localStorage.getItem("role") === Role.STUDENT) {
        this.$router.push("/student/perfiluser");
      }
      if (
        localStorage.getItem("role") === Role.TEACHER ||
        localStorage.getItem("role") === Role.ADMIN
      ) {
        this.$router.push("/learning/perfiluser");
      }
    }
  }
};
</script>

<style>
.p-chip.custom-chip {
  background: var(--primary-color);
  color: var(--primary-color-text);
}
.logo {
  max-width: 150px;
  object-fit: scale-down;
}
</style>



// WEBPACK FOOTER //
// src/components/core/Toolbar.vue